import { render, staticRenderFns } from "./ModalResultadoDiagnosticoFornecedor.vue?vue&type=template&id=11238932&lang=pug"
import script from "./ModalResultadoDiagnosticoFornecedor.vue?vue&type=script&lang=js"
export * from "./ModalResultadoDiagnosticoFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports